import axios from 'axios'
import _ from 'underscore'
import store from '../state/store'

const findLessonPlan = function(lesson_plan_id) {
  const enquiry = store.get().enquiry
  
  return _.first(
    _.select(enquiry.lesson_plans, function(lesson_plan) {
      return lesson_plan.id === lesson_plan_id
    })
  )
}

const findLessonOrder = function(lesson_plan_id, lesson_order_id) {
  const lesson_plan = findLessonPlan(lesson_plan_id)

  return _.first(
    _.select(lesson_plan.lesson_orders, function(lesson_order) {
      return lesson_order.id === lesson_order_id
    })
  )
}

store.on('lesson_plan:lesson_orders:index', function(lesson_plan_id) {
  axios.get(`/api/sales/lesson_plans/${lesson_plan_id}/lesson_orders`)
  .then(function(response) {
    const lesson_plan = findLessonPlan(lesson_plan_id)
    lesson_plan.set({lesson_orders: response.data.lesson_orders})
  })
  .catch(function(error) {
    handleError(error)
  })
})

store.on('lesson_plan:lesson_order:create', function(lesson_plan_id) {
  axios.post(`/api/sales/lesson_plans/${lesson_plan_id}/lesson_orders`)
  .then(function(response) {
    const lesson_plan = findLessonPlan(lesson_plan_id)
    lesson_plan.set({lesson_orders: [response.data.lesson_order]})
    showMessage('Lesson order created.')
  })
  .catch(function(error) {
    handleError(error)
  })
})

store.on('lesson_plan:lesson_order:save', function(lesson_plan_id, lesson_order_id, params) {
  axios.put(`/api/sales/lesson_plans/${lesson_plan_id}/lesson_orders/${lesson_order_id}`, params)
  .then(function(response) {
    const state = store.get()
    state.set({change_applied: false})

    const lesson_order = findLessonOrder(lesson_plan_id, lesson_order_id)
    lesson_order.set(response.data.lesson_order)
    store.emit('pricing_calculator:fetch', lesson_order)
    showMessage('Lesson order saved.')
  })
  .catch(function(error) {
    handleError(error)
  })
})

store.on('lesson_plan:lesson_order:place', function(lesson_plan_id, lesson_order_id, params) {
  axios.put(`/api/sales/lesson_plans/${lesson_plan_id}/lesson_orders/${lesson_order_id}/place`, params)
  .then(function(response) {
    const lesson_order = findLessonOrder(lesson_plan_id, lesson_order_id)
    lesson_order.set(response.data.lesson_order)
    store.emit('pricing_calculator:fetch', lesson_order)
    showMessage('Lesson order placed.')
  })
  .catch(function(error) {
    handleError(error)
  })
})

store.on('lesson_plan:lesson_order:add_to_order', function(lesson_plan_id, lesson_order_id, params) {
  axios.put(`/api/sales/lesson_plans/${lesson_plan_id}/lesson_orders/${lesson_order_id}/add_to_order`, params)
  .then(function(response) {
    const lesson_order = findLessonOrder(lesson_plan_id, lesson_order_id)
    lesson_order.set(response.data.lesson_order)
    store.emit('pricing_calculator:fetch', lesson_order)
    showMessage(`Lesson order added to Order ${params["order_id"]}.`)
  })
  .catch(function(error) {
    handleError(error)
  })
})

store.on('lesson_plan:lesson_order:share', function(lesson_plan_id, lesson_order_id) {
  axios.put(`/api/sales/lesson_plans/${lesson_plan_id}/lesson_orders/${lesson_order_id}/share`)
  .then(function(response) {
    const lesson_order = findLessonOrder(lesson_plan_id, lesson_order_id)
    lesson_order.set(response.data.lesson_order)
    store.emit('pricing_calculator:fetch', lesson_order)
    showMessage('Lesson order shared.')
  })
  .catch(function(error) {
    handleError(error)
  })
})

store.on('lesson_plan:lesson_order:open', function(lesson_order) {
  window.open(lesson_order.url)
})

store.on('lesson_plan:lesson_order:customer_preferences:discard', function(lesson_plan_id, lesson_order_id) {
  axios.put(`/api/sales/lesson_plans/${lesson_plan_id}/lesson_orders/${lesson_order_id}/discard_preferences`)
  .then(function(response) {
    const lesson_order = findLessonOrder(lesson_plan_id, lesson_order_id)
    lesson_order.set(response.data.lesson_order)
    store.emit('pricing_calculator:fetch', lesson_order)
    showMessage('Customer preferences discarded.')
  })
  .catch(function(error) {
    handleError(error)
  })
})

store.on('lesson_plan:finalised_lesson_order:update', function(lesson_plan_id, lesson_order_id, order_id, params) {
  axios.put(`/api/sales/orders/${order_id}/finalised_lesson_orders/${lesson_order_id}`, params)
  .then((response) => {
    const lesson_order = findLessonOrder(lesson_plan_id, lesson_order_id)
    lesson_order.set(response.data.lesson_order)
    store.emit('pricing_calculator:fetch', lesson_order)
    showMessage('Lesson order saved.')
  })
  .catch((error) => {
    handleError(error)
  })
})
